define('atoms-manager',[
    'jquery',
    'underscore',
    'baseview',
    'pubsub',
    'third-party-apis/firefly/firefly',
    'user-manager',
    'utils',
    'managers/autoplay'
],
function(
    $,
    _,
    BaseView,
    PubSub,
    Firefly,
    UserManager,
    Utils,
    AutoPlayManager
) {
    "use strict";

    var AtomsManager = function() {
        this.setup = {
            platform: 'CP',
            analytics: {
                uotrack: function(details) {
                    PubSub.trigger('uotrack', details);
                }
            }
        };
    };

    AtomsManager.prototype = {
        start: function() {
            if(Utils.getNested(window.site_vars, 'cam_messaging', 'enabled')) {
                this.pubSub = {
                    'gravity:hidden': this._showPersistentMeter,
                    'gravity:visible': this._hidePersistentMeter,
                    'activePageInfo:set': this._onActivePageInfoSet
                };
                PubSub.attach(this.pubSub, this);
                this.setup.environment = Utils.getNested(window.site_vars, 'site_env');
                this.setup.siteCode = Utils.getNested(window.site_vars, 'site_code');
                this.setup.camEnabled = Utils.getNested(window.site_vars, 'THIRDPARTYAPI', 'FIREFLY', 'ENABLED');
            }
        },

        stop: function() {
            PubSub.unattach(this.pubSub, this);
        },

        _onActivePageInfoSet: function(pageInfo) {
            this._setViewsData();
            this.setup.protectionState = Utils.getNested(pageInfo, 'content_protection_state');
            this.setup.pageType = Utils.getNested(pageInfo, 'contenttype');
            this.setup.ssts = Utils.getNested(pageInfo, 'ssts');
            this.setup.taxonomy = (Utils.getNested(pageInfo, 'taxonomykeywords') || '').split(',');
            this.setup.roadblock = Utils.getNested(pageInfo, 'roadblock_needed');
            if (this.setup.roadblock) {
                //If there is an inline roadblock, don't allow AutoPlayManager to continue
                AutoPlayManager.register('atoms', _.bind(function() { return $.Deferred().reject(); }, this));
            }
            this._getUser().always(_.bind(function(userInfo) {
                var storedUser = this._getStoredUser();

                userInfo = (!userInfo || userInfo === "Not logged in.") ? storedUser : userInfo.userInfo;

                this.setup.authenticated = Utils.getNested(userInfo, 'meta', 'isAuthenticatedInCurrentContext') || false;
                this.setup.authorized = Utils.getNested(userInfo, 'response', 'user', 'hasMarketAccess') || false;
                this.setup.camId = this.getCamExperienceId();
                this.setup.email = Utils.getNested(userInfo, 'response', 'user', 'email');
                this.setup.user = userInfo;
                this._appendAtomsLibrary();
            }, this));
        },

        _setViewsData: function() {
            var viewsCookie = Firefly.getFireflyViewsCookie() || {};
            this.setup.viewCount = viewsCookie.viewCount;
            this.setup.viewThreshold = viewsCookie.viewThreshold;
        },

        getCamExperienceId: function() {
            return $.cookie('gnt_eid') || $.cookie('cam_eid') || 'control';
        },

        _getUser: function() {
            return UserManager.getAccount('firefly').getUserInfo();
        },

        _getStoredUser: function() {
            return JSON.parse(localStorage.getItem('gupUserInfo'));
        },

        _appendAtomsLibrary: function() {
            if(!$('#gannettAtomsLibrary').length && !Utils.getNested(window.gannett, 'atoms', 'initialized')) {
                var atomsLib = document.createElement('script');
                    atomsLib.async = true;
                    atomsLib.type = 'text/javascript';
                    atomsLib.id = 'gannettAtomsLibrary';
                    atomsLib.src = Utils.getNested(window.cam_messaging, "atoms_library_url") ? Utils.getNested(window.cam_messaging, "atoms_library_url") : "https://atoms." + Utils.getNested(window.site_vars, 'base_url') + "/atoms-library/" + this.setup.environment + "/dist/gannett-atoms-library.js";
                var node = document.getElementsByTagName('script')[0];
                node.parentNode.insertBefore(atomsLib, node);
            }
        },

        _showPersistentMeter: function() {
            $('cta-atoms-container-persistent-fixed').show();
        },

        _hidePersistentMeter: function() {
            $('cta-atoms-container-persistent-fixed').hide();
        }
    };
    
    if(window.gannett) {
        window.gannett.atoms = new AtomsManager();
    } else {
        window.gannett = {
            atoms: new AtomsManager()
        };
    }
    return window.gannett.atoms;
});

